import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const PaperClip = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 12 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M2.98573 3.25357V7.00357C2.98573 7.74324 3.58534 8.34286 4.32501 8.34286C5.06468 8.34286 5.6643 7.74324 5.6643 7.00357V3.11964C5.6643 1.71428 4.52502 0.575001 3.11965 0.575001C1.71429 0.575001 0.575012 1.71428 0.575012 3.11964L0.575012 7.27143C0.575012 9.3425 2.25394 11.0214 4.32501 11.0214C6.39608 11.0214 8.07501 9.3425 8.07501 7.27143V3.25357"
        stroke={color}
        strokeWidth="1.15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default PaperClip
